import Auth from '../api/auth';
import { clearCookiesOnLogout } from 'dashboard/store/utils/api';

const AUTHORIZATION_ERROR_MESSAGES = [
  'You are not authorized to do this action',
  'You are not authorized to access this account',
  'Account is suspended',
];

const responseErrorMessage = error => {
  const data = error?.response?.data;
  if (!data) return '';
  if (typeof data === 'string') return data;
  if (data.error) return data.error;
  if (data.message) return data.message;
  if (Array.isArray(data.errors)) return data.errors.join(' ');
  return '';
};

const isAuthorizationError = error => {
  const message = responseErrorMessage(error);
  return AUTHORIZATION_ERROR_MESSAGES.some(errorMessage =>
    message.includes(errorMessage)
  );
};

const parseErrorCode = error => {
  if (
    error?.response?.status === 401 &&
    Auth.hasAuthCookie() &&
    !isAuthorizationError(error)
  ) {
    clearCookiesOnLogout({ automatic: true });
  }

  return Promise.reject(error);
};

const syncAuthHeaders = (wootApi, config = null) => {
  if (!Auth.hasAuthCookie()) return config;

  const {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  } = Auth.getAuthData();

  const authHeaders = {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  };

  Object.assign(wootApi.defaults.headers.common, authHeaders);
  if (config) {
    return {
      ...config,
      headers: {
        ...(config.headers || {}),
        ...authHeaders,
      },
    };
  }

  return config;
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  syncAuthHeaders(wootApi);
  wootApi.interceptors.request.use(config => {
    return syncAuthHeaders(wootApi, config);
  });
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
